import dynamic from 'next/dynamic';
const TechForSport = dynamic(() => import('./TechForSport'));
export default TechForSport;
